/**
 * This module modifies the SCORM player data to hide a slide.
 * If slideNumber = -2:
 *  - Finds the last slide and the knowledge check slide before it
 *  - then modifies the slide before the knowledge check to link directly to the last slide
 *  - and modifies the last slide to link back to the slide before the knowledge check, effectively hiding the knowledge check slide.
 *
 * If slideNumber = another number
 * - can be extended in the future to hide specific slides by their slide number
 */
export default (scormHijackParams, slideNumber) => {
  const { type, payload, iframeContentWindow } = scormHijackParams;
  const LOG = (...a) => {
    if (localStorage.getItem('treadmaster_scormdebug') === 'true') {
      console.log('[Treadmaster SCORM:hide-slide] ', ...a);
    }
  };
  const LOGTABLE = (a) => {
    if (localStorage.getItem('treadmaster_scormdebug') === 'true') {
      console.log('[Treadmaster SCORM:hide-slide]');
      console.table(a);
    }
  };

  LOG(slideNumber);
  LOG(type);
  LOG(iframeContentWindow);
  LOGTABLE(payload);

  //
  const SLIDE_KNOWLEDGE_CHECK = -2;
  const PAYLOAD_TYPE_DATA = 'data';
  const PAYLOAD_TYPE_SLIDE = 'slide';
  const STORE_KEY = '__treadmaster_scorm_hide_slide';
  //
  let injectedStyles = '';

  //prepare internal states to iframeContentWindow
  iframeContentWindow[STORE_KEY] = iframeContentWindow[STORE_KEY] || {
    slideBeforeKnowledgeCheckId: '',
    lastSlideId: ''
  };
  const store = iframeContentWindow[STORE_KEY];

  //
  if (slideNumber === SLIDE_KNOWLEDGE_CHECK) {
    if (type === PAYLOAD_TYPE_DATA) {
      // Styles for hiding the knowledge check slide in the sidebar
      const hideCSS = `
      nav#outline-content li[role*="treeitem"]:nth-last-child(2){
        display: none;
      }
      `;
      injectedStyles += hideCSS;

      /*
       * Set passing grade to zero so that when the user reaches the last slide
       * - knowledge check is set to status passed
       * - the scorm activity is marked complete
       */
      const quiz = payload?.quizzes?.[0];
      if (quiz?.kind === 'quiz') {
        quiz.passPercent = 0;
      }

      //find the last slide
      const lastSlide = payload?.slideMap?.slideRefs?.slice(-1)?.[0];
      LOG(`lastSlideId: ${lastSlide?.id}`);

      //store the id of the last slide in the internal state for later use
      store.lastSlideId = lastSlide?.id;

      //get ref to the previous slide (knowledge check)
      let knowledgeCheckSlideId = lastSlide?.linksTo?.[0]?.id;

      //CASE: where the lastSlide doesn't have a linksTo map
      if (!knowledgeCheckSlideId) {
        //check variables array for the first CurrentQuiz prefix
        const variables = payload?.variables || [];
        if (variables.length === 0) {
          LOG('No variables found in payload');
        }

        const currentQuizEntries = variables.filter((variable) => {
          return variable.name.startsWith('CurrentQuiz');
        });
        if (currentQuizEntries.length === 0) {
          LOG('No CurrentQuiz variables found in payload');
        }

        const currentQuizEntry = currentQuizEntries[0];
        const currentQuizEntryParsedName =
          currentQuizEntry?.name?.split('_') || [];
        const knowledgeCheckSlideIdFromVariable =
          currentQuizEntryParsedName?.[currentQuizEntryParsedName.length - 1];
        LOG(
          `knowledgeCheckSlideIdFromVariable: ${knowledgeCheckSlideIdFromVariable}`
        );

        //Find the slide with the id that matches knowledgeCheckSlideIdFromVariable
        const knowledgeCheckSlideFromVariable =
          payload?.slideMap?.slideRefs?.find((slide) =>
            slide.id.includes(knowledgeCheckSlideIdFromVariable)
          );
        LOG(
          `knowledgeCheckSlideFromVariableId: ${knowledgeCheckSlideFromVariable?.id}`
        );

        if (knowledgeCheckSlideFromVariable) {
          knowledgeCheckSlideId = knowledgeCheckSlideFromVariable.id;
        }
      }

      const knowledgeCheckSlide = payload?.slideMap?.slideRefs?.find(
        (slide) => slide.id === knowledgeCheckSlideId
      );
      LOG(`knowledgeCheckSlideId: ${knowledgeCheckSlide?.id}`);

      //get the slide before the knowledge check
      const indexOfKnowledgeCheck = payload?.slideMap?.slideRefs?.findIndex(
        (slide) => slide.id === knowledgeCheckSlideId
      );
      const slideBeforeKnowledgeCheck =
        payload?.slideMap?.slideRefs?.[indexOfKnowledgeCheck - 1];
      LOG(`slideBeforeKnowledgeCheckId: ${slideBeforeKnowledgeCheck?.id}`);

      //store the id of the slide before the knowledge check in the internal state
      store.slideBeforeKnowledgeCheckId = slideBeforeKnowledgeCheck?.id;

      //
      LOG(`store`);
      LOGTABLE(store);
    }

    if (type === PAYLOAD_TYPE_SLIDE) {
      LOG(
        `lmsId: ${payload.lmsId} | id: ${payload.id} | slideBeforeKnowledgeCheckId: ${store.slideBeforeKnowledgeCheckId} | lastSlideId: ${store.lastSlideId}`
      );

      //
      const isCurrentSlideBeforeKnowledgeCheck =
        store.slideBeforeKnowledgeCheckId.includes(payload?.id);
      const isCurrentSlideLastSlide = store.lastSlideId.includes(payload?.id);

      //set the slide before the knowledge check to link directly to the last slide, skipping the knowledge check
      if (isCurrentSlideBeforeKnowledgeCheck) {
        //next button
        const nextButtonClickAction =
          payload?.actionGroups?.ActGrpOnNextButtonClick?.actions?.[0];

        if (nextButtonClickAction.kind === 'gotoplay') {
          nextButtonClickAction.objRef = nextButtonClickAction.objRef || {};
          nextButtonClickAction.objRef.value = `_player.${store.lastSlideId}`;
          LOG(`Modified slide ${payload.id} to skip knowledge check`);
        }
      }

      //set the last slide prev button to link directly to the slide before the knowledge check, skipping the knowledge check
      if (isCurrentSlideLastSlide) {
        //prev button
        const prevButtonClickAction =
          payload?.actionGroups?.ActGrpOnPrevButtonClick?.actions?.[0];

        if (prevButtonClickAction.kind === 'gotoplay') {
          prevButtonClickAction.objRef = prevButtonClickAction.objRef || {};
          prevButtonClickAction.objRef.value = `_player.${store.slideBeforeKnowledgeCheckId}`;
          LOG(`Modified slide ${payload.id} to skip knowledge check`);
        }
      }
    }

    if (type === PAYLOAD_TYPE_DATA) {
      //inject the custom styles
      const styleElement = document.createElement('style');
      styleElement.textContent = injectedStyles;
      iframeContentWindow.document.head.appendChild(styleElement);
    }
  }
};
